import { ClientState, EmailDTO, AddressDTO, PhoneDTO } from './client.model';

const reducers = {
  storeAddresses: (state: ClientState, payload: AddressDTO[]) => ({
    ...state,
    addresses: payload
  }),
  storePhones: (state: ClientState, payload: PhoneDTO[]) => ({
    ...state,
    phones: payload
  }),
  storeEmails: (state: ClientState, payload: EmailDTO[]) => ({
    ...state,
    emails: payload
  })
};

export default reducers;
